var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import deleteFeed from '../../requests/feed/deleteFeed';
import Signals from '../../signals/Signals';
/**
 *
 */
var DeleteFeedCommand = /** @class */ (function (_super) {
    __extends(DeleteFeedCommand, _super);
    function DeleteFeedCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param organisation OrganisationModel
     * @param feed FeedModel
     * @param feedCollection FeedCollection
     * @param intl
     * @return {*}
     */
    DeleteFeedCommand.prototype.execute = function (organisation, feed, feedCollection, intl) {
        this.intl = intl;
        this.feed = feed;
        this.feedCollection = feedCollection;
        var promise = deleteFeed(feed.id, organisation.id);
        promise.then(this.then);
        return promise;
    };
    /**
     *
     * @param response
     */
    DeleteFeedCommand.prototype.then = function (response) {
        // Remove from collection
        this.feedCollection.remove(this.feed);
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.feed.deleted' }, Object(this.feed)), 'dark', true);
    };
    return DeleteFeedCommand;
}(Command));
export default DeleteFeedCommand;
